const $ = require('jquery');

function CardSizeService(settingsService, breakpointsService, localStorageService) {
    this.currentSize = 0;

    // They are saved as strings in local storage
    this.sizes = {
        Normal: '0',
        Compact: '1',
        Row: '2'
    };

    this.settingsService = settingsService;
    this.enabled = false;
    this.hasLoadedSetting = false;
    this._breakpointService = breakpointsService;
    this._localStorage = localStorageService;
    return this;
}

CardSizeService.prototype.initialise = function () {
    const self = this;
    this.settingsService.getSettingValue('OneSite', 'SmallerProductStampsEnabled').then(enabled => {
        this.hasLoadedSetting = true;
        this.enabled = enabled;
        if (enabled && !self._breakpointService.isInSmallFormat) {
            this.setSize(this._localStorage.getItem('stampSizePreference'));
        } else {
            this.setSize(this.sizes.Normal);
        }
    });
};

CardSizeService.prototype.getSize = function (smallerProductStampsEnabled) {
    if (smallerProductStampsEnabled) {
        this.addCardClass();
        return this.currentSize;
    }

    $('html').removeClass('cardViewNormal cardViewCompact cardViewRow');
    return this.sizes.Normal;
};

/**
Usage:
@param view
    Required, expects an entry from cardSizeService.views.*
@param writeToLocalstorage
    Optional, will save the change to localstorage unless set to false
*/
CardSizeService.prototype.setSize = function (view, writeToLocalstorage) {
    if (this.currentSize === view) {
        return;
    }

    if (!this.hasLoadedSetting) {
        view = this.sizes.Normal;
        writeToLocalstorage = false;
    }

    $('html').removeClass('cardViewNormal cardViewCompact cardViewRow');

    switch (view) {
    case this.sizes.Compact:
        $('html').addClass('cardViewCompact');
        this.currentSize = this.sizes.Compact;
        break;
    case this.sizes.Row:
        $('html').addClass('cardViewRow');
        this.currentSize = this.sizes.Row;
        break;
    case this.sizes.Normal:
    default:
        this.currentSize = this.sizes.Normal;
        $('html').addClass('cardViewNormal');
        writeToLocalstorage = true; // If it was the default case then save over the old value
    }

    if (writeToLocalstorage !== false) {
        this._localStorage.setItem('stampSizePreference', this.currentSize);
    }
};


CardSizeService.prototype.addCardClass = function () {
    switch (this.currentSize) {
    case this.sizes.Compact:
        if (!$('html').hasClass('cardViewCompact')) {
            $('html').addClass('cardViewCompact');
        }
        break;
    case this.sizes.Row:
        if (!$('html').hasClass('cardViewRow')) {
            $('html').addClass('cardViewRow');
        }
        break;
    case this.sizes.Normal:
    default:
        if (!$('html').hasClass('cardViewNormal')) {
            $('html').addClass('cardViewNormal');
        }
    }
};


module.exports = CardSizeService;


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/cards/card-size-service.js
 **/